export default __webpack_public_path__ + "static/media/about-friend-icon.9e1e797c.svg";